<template>
  <div class="pages_su_one">
    <div class="pages_ab">
      <div class="pages_title fx fa_c"> 
          <div class="fs_06 fw_6 pr01">公司简介</div>
          <div class=" fs_03 ls2">COMPANY OVERVIEW</div>
      </div>
      <div class="ab_content">
        <img src="@/assets/summany/hexin/hx_top.png" class="content_img">
        <div class="cthree ml_4 mt02">
            <div class="th_item fsa pd3 mb03 wow animate__animated animate__fadeInLeft">
                <div class="item_l fs_035 fw_8 tc">
                    <img src="@/assets/summany/hexin/icon1.png" class="th_icon pb01">
                    <div class="color1">一站式服务</div>
                </div>
                <div class="item_r fs_03 lh044 pt01">
                    数字创意展示工程,信息化技术软件开发,
                    多媒体展项应用集大成者,为客户提供一站
                    式数字展厅解决方案和策划、设计、实施一
                    体化服务。
                </div>
            </div>
            <div class="th_item fsa pd3 mb03 wow animate__animated animate__fadeInRight">
                <div class="item_l fs_035 fw_8 tc">
                    <img src="@/assets/summany/hexin/icon1.png" class="th_icon pb01">
                    <div class="color1">广泛业务范围</div>
                </div>
                <div class="item_r fs_03 lh044 pt01">
                    十多年的专业服务经验,服务各领域诸多经
                    典展览展示项目;信息化技术软件开发业务
                    覆盖城市治理、工业制造、文旅产业、教育
                    培训等领域。
                </div>
            </div>
            <div class="th_item fsa pd3 mb03 wow animate__animated animate__fadeInLeft">
                <div class="item_l fs_035 fw_8 tc">
                    <img src="@/assets/summany/hexin/icon1.png" class="th_icon pb01">
                    <div class="color1">顶尖设计团队</div>
                </div>
                <div class="item_r fs_03 lh044 pt01">
                    专业服务团队,拥有一批行业专家与工程师
                    精英人才队伍,同时与国内多家985院校以
                    及科研机构达成长期深度战略合作。
                </div>
            </div>
            <div class="th_item fsa pd3 mb03 wow animate__animated animate__fadeInRight">
                <div class="item_l fs_035 fw_8 tc">
                    <img src="@/assets/summany/hexin/icon1.png" class="th_icon pb01">
                    <div class="color1">及时运维服务</div>
                </div>
                <div class="item_r fs_03 lh044 pt01">
                    公司拥有强大的售后运维工程师团队,为客
                    户提供全方位的及时、高效、稳定的售后
                    务。
                </div>
            </div>
            
        </div>
      </div>

    </div>
   
  </div>
</template>
<script  setup>
import { ref, nextTick, onMounted } from 'vue'
onMounted(() => {

});
</script>
<style  scoped>
.pages_su_one {
  width: 100%;
  height: 100%;
  z-index: 6;
  position: relative;
}
.pages_ab{
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
 
}
.pages_title{
  position:absolute;
  top: 4%;
  left: 3%;
  color: #fff;

}
.ab_content{
  position: absolute;
  top: 10%;
  left: 0;
  width: 94%;
  margin: 0 3%;
  height: 86%;
  background-color: #fff;
  border-top-left-radius: 0.6rem;
  border-bottom-right-radius: 0.6rem;
  overflow-y: auto;
}
.content_img{
  width: 92%;
  height: auto;
  margin: 4% 4%;
}
.th_item{
    background-color: #e6eefb;
    border-radius: 0.3rem;
    color: #5d5d5f;
}
.th_icon{
    width: 1rem;
    height: 1rem;
}
.item_l{
    width: 27%;
}
.item_r{
    width: 68%;
}


</style>

